<template>
	<div>
		<div class="home mid-autumn"  :class="{'toptoptop':client_type!='app'}">
			<div class="header" v-if="client_type!='app'" ref="head">
				<span class="records" @click="exchange">兑换</span>
			</div>

			<div class="header2" v-if="client_type=='app'" ref="appHead">
				<span class="records" @click="exchange">兑换</span>
			</div>


			<div class="phoneNumber" ref="phone">
				<input type="number" pattern="[0-9]*" value="" @blur="getBelongto()" v-model="phoneNum" maxlength="11" @keyup="filterNum()" placeholder="请输入手机号" />
				<p class="text" v-show="showProvince">默认号码（{{province}}{{platform}}）</p>
			</div>

			<div ref="list" class="listContent">
					<!-- <div class="banner">
						<div>充话费</div>
						<div class="goRecord" @click="getRecords(0)">充值记录</div>
					</div>

				<div class="recharge-list " >
					<ul>
						<li class="unchecked" v-for="(item,index) in packageList" v-bind:key="index" :class="{'checked':index==isChecked&&currentIndex==0}" @click="choosePackage(index,item.id,item.desc,item.price,0)">
							<p class="slow-icon" v-show="item.type == 1"></p>
							<p class="recommend" v-show="item.is_top == 1"></p>
							<p class="money">{{item.amount}}</p>
							<p class="price" :class="{'type':item.type == 1}">售价{{item.price}}元</p>
							<p class="gift" v-show="item.gifts > 0">送{{item.gifts}}元ELB</p>
						</li>
					</ul>
			</div> -->

			<div class="banner2" v-if="!isIos"  >
				<div>更多福利</div>
				<div class="goRecord" @click="getRecords(1)">购买记录</div>
				
			</div>
			<div class="youku-list " v-if="!isIos" >
				<!-- <p class="line"></p> -->
				<!-- <div class="rechargeMsg">
					<div>更多福利</div>
					<div @click="getRecords(1)">购买记录</div>
				</div> -->
				<div class="youkuSEVEN" @click="goThird()">
						<img class="buybuybuy" src="../assets/img/buybuybuy.gif" alt="" loop=true>
				</div>
				<ul>
					<li class="unchecked" 
						v-for="(item,index) in youkuList" 
						v-bind:key="index" 
						:class="{'checked':index==isChecked&&currentIndex==1}" 
						@click="choosePackage(index,item.id,null,item.price,1)">
						<!-- <p class="slow-icon" v-show="item.type == 1"></p> -->
						<!-- <p class="recommend" v-show="item.is_top == 1"></p> -->
						<p :class="'icon' + item.id"></p>
						<p class="price" >{{item.price}} <span class="yuan">元</span></p>
						<!-- <p class="gift" >{{item.name}}</p> -->
						<p class="money">原价{{item.original_price}}元</p>
					</li>
				</ul>
			</div>
			<div class="ios-describe" v-if="isIos">
				暂未开放，敬请期待
			</div>
			<div class="rules" ref="rules" v-if="!isIos">
				<div >
					<p class="title">规则说明：</p>
					<!-- <p class="content" v-html="description">{{description}}</p> -->
					<p class="content" v-if="!isIos" >1.购买优酷会员，购买成功后优酷会员会自动发放到您填写的手机号码，可登录填写的手机号码进行登录查看</p>
					<!-- <p class="content" v-if="!isIos" >3.充值话费及购买优酷会员成功后，不可退换。</p> -->

				</div>
			</div>
			</div>

			<div class="btn-area" ref="button">
				<p class="confirm" @click="confirmRecharge">立即抢购</p>
			</div>
			<!--<div class="clear_btn" @click="clearData">清除</div>-->

			<div class="prompt-box shade" v-show="showPrompt">
				<div class="wrapper">
					<div class="button-area">
						<div class="cancel" @click="cancelGo"></div>
						<div class="confirm" @click="confirmGo"></div>
					</div>
				</div>
			</div>

			<!--个人信息-->
			<!-- <pesonalInfo :info="userInfo" @open='showRechargeBox'  v-if="client_type!='app'"></pesonalInfo> -->

			<!--充值提示-->
			<rechargePrompt v-show="showRechargePrompt" @colse='closeRechargePrompt' :rechargeInfo="recharge_list"></rechargePrompt>

			<!--支付提示-->
			<payPrompt v-show="showPayPrompt" @closePay="closePayPrompt" :payInfo='pay_info' @confirm_pay="confirmRecharge"></payPrompt>
		</div>
		<!-- <div class="fixing">
			<h2>维护中...敬请原谅</h2>
		</div> -->
	</div>

</template>
<script>
	import { rechargeParam, getUrlRelativePath } from '../assets/js/common.js'
	import pesonalInfo from './personal_info'
	import payPrompt from './pay_prompt'
	import rechargePrompt from './recharge_prompt'
	import Vue from 'vue'

	//	const reg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
	const reg = /^(13[0-9]|14[0-9]|15[0-9]|16[6]|17[0-9]|18[0-9]|19[89])\d{8}$/;

	let phoneNumber = '';
	export default {
		data() {
			return {
				showPayPrompt: false,
				isChecked: -1,
				packageList: {},
				phoneNum: '',
				showProvince: false,
				platform: '',
				province: '',
				packageId: 0,
				description: '1.每充值一笔话费赠送ELB，可在十秒挑战内兑换金币，赢取奖品 多充多送！',
				showPrompt: false,
				path: '',
				client_type:'',
				redirect_url: this.redirect_url,
				auth: false,
				decrypt_data: {},
				state: '',
				userInfo: {},
				pay_info: {},
				packagePrice: 0,
				recharge_list: [],
				showRechargePrompt: false,
				youkuList:[],
				isIos:false,
				currentIndex:0       //0充值   1优酷
				//					pay_type:'WEIXINH5'
				//					isRefreshToken:false,
			}
		},
		created() {

			//			document.addEventListener("plusready", this.plusReady, false);
			let _this = this;
			if(!this.environment) {
				if(localStorage.getItem('version') != this.version) {
					localStorage.removeItem("token");
					localStorage.removeItem("auth_data");
				}
			}

			let UA = navigator.userAgent.toLowerCase();
			//			this.getAppToken();
			//		授权
			if(/(uni-app)/.test(UA) || /(ylkids_android)/.test(UA) || /(ios1.1.0)/.test(UA)) {
				this.client_type="app";
				if(/(ios1.1.0)/.test(UA)){
					this.isIos=true;
				}
				Vue.prototype.environment = true;

				if(/(ylkids_android)/.test(UA)) {
					let str3 = window.jsInterface.GetToken();
					localStorage.setItem("token", str3);
					//  获取用户信息
					this.getUserInfo();
					//	获取充值列表
					this.getRechargeList();
				} else if(/(ios1.1.0)/.test(UA)) {
					//ios环境下触发有点慢
					// window.webkit.messageHandlers.tokenTnvalid.postMessage(null);
					
					window.webkit.messageHandlers.getIosToken.postMessage(null);
					setTimeout(function() {
						//  获取用户信息
						_this.getUserInfo();
						//	获取充值列表
						_this.getRechargeList();
					}, 500)

				}
			} else {
				if(localStorage.getItem('token')) {
					//  获取用户信息
					this.getUserInfo();
					//	获取充值列表
					this.getRechargeList();

				} else {
					if(this.getUrlParam("data")) {
						localStorage.setItem('auth_data', this.getUrlParam("data"));
					}

					if(localStorage.getItem('auth_data') && localStorage.getItem('version') == this.version) {
						if(localStorage.getItem("state") == this.getUrlParam("state")) {
							// 解密data
							this.$http.post("/api/v2/secret/decrypt?" + rechargeParam({}, true, true), {
								data: localStorage.getItem('auth_data')
							}, {
								emulateJSON: true
							}).then((response) => {
								if(response.data.error == 0) {

									this.decrypt_data = response.data.data.data;
									//用户登录
									if(this.isAlipayOrWechat().split(',')[0] == 'alipay') {
										localStorage.setItem('openid', response.data.data.data.user_id);
										localStorage.setItem('nickname', response.data.data.data.user_id);
										localStorage.setItem('gender', response.data.data.data.gender);
										localStorage.setItem('avatar', response.data.data.data.avatar);

									} else if(this.isAlipayOrWechat().split(',')[0] == 'wechat') {
										localStorage.setItem('openid', response.data.data.data.unionid);
										localStorage.setItem('nickname', response.data.data.data.nickname);
										localStorage.setItem('gender', response.data.data.data.sex);
										localStorage.setItem('avatar', response.data.data.data.headimgurl);
									}

									//									localStorage.setItem('openid',response.data.data.data.openid);
									//									localStorage.setItem('nickname',response.data.data.data.nickname);
									//									localStorage.setItem('gender',response.data.data.data.sex);
									//									localStorage.setItem('avatar',response.data.data.data.headimgurl);
									//									localStorage.setItem('decrypt_data',this.decrypt_data);
									//									console.log(this.decrypt_data)

									//用户登录
									this.$http.post("/api/v2/auth/login?" + rechargeParam({}, true, true), {

										uuid: localStorage.getItem("openid"),
										code: response.data.data.code

									}, {
										emulateJSON: true
									}).then((response) => {
										if(response.data.error == 0) {
											//											console.log("用户登录"+response.data.data);
											localStorage.setItem("token", response.data.data);
											//											alert("用户登录")
											//获取用户信息
											this.getUserInfo();
											//	获取充值列表
											this.getRechargeList();
										} else if(response.data.error == "11002") {
											//											this.refreshToken();
											this.$emit("getToken");
										} else if(response.data.error == '30005') {
											this.$router.push({
												path: 'bind'
											})

										} else if(response.data.error == '11003') {
											this.$router.push({
												path: 'bind'
											})
										} else {
											alert(response.data.msg);
										}
									})

								} else if(response.data.error == "11002") {
									//									this.refreshToken();
									this.$emit("getToken");
								} else {
									alert(response.data.msg);

								}
							})
						} else {
							//							location.reload();
													this.state = Math.random().toString(36).substr(2);
						localStorage.setItem('state', this.state);
						//						console.log(this.state)
						localStorage.setItem('currentRouter', getUrlRelativePath())
						this.$http.get("/api/v2/oauth/authorize?" + rechargeParam({
							params: {
								client_type: this.isAlipayOrWechat().split(',')[0],
								redirect_uri: this.redirect_url,
								scope: 'userinfo',
								state: this.state
							}
						}, false, true)).then((response) => {
							if(response.data.error == 0) {
								localStorage.setItem("version", this.version);
								window.location.href = response.data.data;
							} else if(response.data.error == "11002") {
								//								this.refreshToken();
								this.$emit("getToken");
							} else {
								alert(response.data.msg);

							}
						})
						}

					} else {
						this.state = Math.random().toString(36).substr(2);
						localStorage.setItem('state', this.state);
						//						console.log(this.state)
						localStorage.setItem('currentRouter', getUrlRelativePath())
						this.$http.get("/api/v2/oauth/authorize?" + rechargeParam({
							params: {
								client_type: this.isAlipayOrWechat().split(',')[0],
								redirect_uri: this.redirect_url,
								scope: 'userinfo',
								state: this.state
							}
						}, false, true)).then((response) => {
							if(response.data.error == 0) {
								localStorage.setItem("version", this.version);
								window.location.href = response.data.data;
							} else if(response.data.error == "11002") {
								//								this.refreshToken();
								this.$emit("getToken");
							} else {
								alert(response.data.msg);

							}
						})

					}
				}
			}

			//				获取充值套餐列表
			console.log(88822)
			this.getList(0, 0);

			let mobile = this.getUrlParam("mobile");

			if(mobile) {
				this.phoneNum = mobile;
			} else {
				this.phoneNum = phoneNumber.substring(phoneNumber.lastIndexOf(",") + 1, phoneNumber.length);
			}
			//				获取手机归属地
			if(localStorage.getItem("telphone")) {
				if(phoneNumber.indexOf(localStorage.getItem("telphone")) == -1) {
					phoneNumber += localStorage.getItem("telphone");
				}

				//					console.log(localStorage.getItem("telphone").length)

				this.getBelongto();

			}
		},
		methods: {

			getUserInfo() {
				//获取用户信息
				this.$http.get("/api/v2/user/info?" + rechargeParam({
					params: {

					}
				}, false, true)).then((response) => {
					if(response.data.error == 0) {
						this.userInfo = {
							elb: response.data.data.account.elb,
							rmb: response.data.data.account.rmb
						}
					} else if(response.data.error == "11002") {
						//							this.refreshToken();
						this.$emit("getToken");
					} else {
						alert(response.data.msg);
					}
				})
			},
			getRechargeList() {
				this.$http.get("/api/v2/recharge/config?" + rechargeParam({
					params: {

					}
				}, false, true)).then((response) => {
					if(response.data.error == 0) {

						this.recharge_list = response.data.data;
					} else if(response.data.error == "11002") {
						//							this.refreshToken();
						this.$emit("getToken");
					} else {
						alert(response.data.msg);

					}
				})
			},
			filterNum() {
				if(this.phoneNum.substring(0, 3) == '145' || this.phoneNum.substring(0, 3) == '146') {
					this.showPrompt = true;
				}
			},
			getList(prov_id, plat_id) {
				console.log(888)
				this.$http.get("/test/v1/package/list?" + rechargeParam({
					params: {
						prov_id: prov_id,
						plat_id: plat_id
					}
				}, false, false)).then((response) => {

					if(response.data.error == 0) {
						if(response.data.data != '') {
							this.packageList = response.data.data;
							this.getYoukuList();
						} else {
							this.getList(0, 0);
							this.getYoukuList();
						}
					} else if(response.data.error == "30005") {

					} else {
						alert(response.data.msg);
					}
				})
			},
			getRecords(type) {
				this.$router.push({
					path: 'recharge-list',
					query:{
						type:type
					}
				})
			},
			cancelGo() {
				this.showPrompt = false;
			},
			confirmGo() {
				if(this.isAlipayOrWechat().split(',')[1]) {
					window.location.href = this.isAlipayOrWechat().split(',')[1];
				} else {
					alert("请在微信或者支付宝打开")
				}

			},
			choosePackage(index, id, desc, price,type) {
				this.isChecked = index;
				this.packageId = id;
				this.description = desc?"1."+desc:"1.每充值一笔话费赠送ELB，可在十秒挑战内兑换金币，赢取奖品 多充多送！";  
				this.packagePrice = price;
				this.currentIndex=type;
			},
			getBelongto() {
				if(this.phoneNum != '' && reg.test(this.phoneNum)) {
					this.$http.get("/test/v1/mobile/belongs-to?" + rechargeParam({
						params: {
							mobile: this.phoneNum
						}
					}, false, false)).then((response) => {
						if(response.data.error == 0) {
							this.showProvince = true;
							this.province = response.data.data.province;
							this.platform = response.data.data.platform;

							this.getList(response.data.data.prov_id, response.data.data.plat_id);
						} else if(response.data.error == "30005") {

						} else {
							alert(response.data.msg);

						}
					})
				} else {
					this.showProvince = false;
				}
			},
			confirmRecharge(data) {
				if(this.phoneNum == '') {
					alert("手机号码不能为空");
					return false;
				}
				if(!reg.test(this.phoneNum)) {
					alert("请填写正确的手机号码");
					return false;
				}
				if(this.isChecked < 0) {
					alert("请选择充值套餐");
					return false;
				}

				if(this.currentIndex==0){
					if(this.phoneNum.substring(0, 3) == '145' || this.phoneNum.substring(0, 3) == '146') {
						this.showPrompt = true;
						return false;
					}
				}
				if(data.dedution) {
					let url="";
					if(this.currentIndex==0){
						url="/test/v1/recharge/submit?";
						data={
								mobile: this.phoneNum,
								package_id: this.packageId,
								deduction: data.money,
								pay_type: data.pay_type
						}
						localStorage.setItem("currentRecharge","recharge");
					}else{
						url="/test/v1/yk-vip/pay-submit?";
						data={
								mobile: this.phoneNum,
								package_id: this.packageId,
								pay_type: data.pay_type?data.pay_type:"WEIXIN",
								deduction_rmb: data.money,
						}
						localStorage.setItem("currentRecharge","youku");

					}
						this.$http.post(url + rechargeParam({}, true, false), data, {
								emulateJSON: true
							}).then((response) => {
								if(phoneNumber != '') {
									if(phoneNumber.indexOf(this.phoneNum) == -1) {
										phoneNumber += ',' + this.phoneNum;
									}
								} else {
									phoneNumber += this.phoneNum;
								}

								localStorage.setItem("telphone", phoneNumber);

								let urlReg = /^((https|http|ftp|rtsp|mms)?:\/\/)+[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/;
								let htmlReg = /<[^>]+>/gim;
								if(urlReg.test(response.data)) {
									window.location.href = response.data;
								} else if(htmlReg.test(response.data)) {
									document.write(response.data);
								} else {
									if(response.data.status ==200) {
										alert("购买成功");
										location.reload();
									} else {
										alert(response.data.msg)
									}
								}
							})
				}
				else{
					
					this.showPayPrompt = true;
					this.pay_info = {
						price: this.packagePrice,
						rmb: Number(this.userInfo.rmb).toFixed(2),
						currentIndex:this.currentIndex,
					}
				}
			},
			//				refreshToken(){
			//					// 刷新token
			//					this.$http.get("/api/v2/auth/refresh?"+rechargeParam({
			//						params:{
			//							token:localStorage.getItem("token")
			//						}
			//					},false,true)).then((response) => {
			//						if(response.data.error == 0){
			//							localStorage.setItem("token",response.data.data);
			////							alert("刷新token："+localStorage.getItem("token"))
			//							this.isRefreshToken = true;
			//							//	获取充值列表
			//							
			//							setTimeout(() => {
			//								this.getUserInfo();
			//			                    this.getRechargeList();
			//			                }, 500);
			//						}else if(response.data.error == "11002"){
			//							
			//						}else{
			//							alert(response.data.msg);
			//							
			//						}
			//					})
			//				},
			showRechargeBox() {
				this.showRechargePrompt = true;
			},
			closeRechargePrompt() {
				this.showRechargePrompt = false;
			},
			closePayPrompt() {
				this.showPayPrompt = false;
			},
			//				isAlipayOrWechat(){
			//			    		var userAgent = navigator.userAgent.toLowerCase();
			//				
			//				    if(userAgent.match(/Alipay/i) == "alipay") {
			//				        this.path = 'http://zfb.china-m2m.com/weixin/new_auth';
			//				        this.client_type = 'alipay';
			//				    } else if(userAgent.match(/MicroMessenger/i) == "micromessenger") {
			//				        this.path = 'http://wx.china-m2m.com/weixin/new_auth';
			//				        this.client_type = 'wechat';
			//				    }
			//				},
			//			getUrlParam(name) {
			//				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
			//				var r = window.location.search.substr(1).match(reg); //匹配目标参数
			//				if(r != null) return unescape(r[2]);
			//				return null; //返回参数值
			//			},
			clearData() {
				localStorage.clear();
			},
			exchange(){
				this.$router.push({
					path: 'exchange'
				})
			},
			getYoukuList(prov_id, plat_id) {
				let _this=this;
				this.$http.get("/test/v1/yk-package/list?" + rechargeParam({}, false, false)).then((response) => {
					if(response.data.error == 0) {
							this.youkuList = response.data.data;



							this.$nextTick(() => {
								
              	let clientHeight = document.documentElement.clientHeight || document.body.clientHeight,
              	  ref1 ,
									ref2 ,
									ref3 = _this.$refs.phone.offsetHeight,
              	  ref4 = _this.$refs.button.offsetHeight;
									if(this.$refs.head){
										ref1= this.$refs.head.offsetHeight
									}
									if(this.$refs.appHead){
										ref2= this.$refs.appHead.offsetHeight
									}


              	if (this.client_type === 'app' ) {
              	  this.$refs.list.style.height = (clientHeight - ref2 - ref3 - ref4  ) + 'px'
              	} else {
									this.$refs.list.style.height = (clientHeight - ref1 - ref3 - ref4   )  + 'px';
								}
								
            	});
					} else if(response.data.error == "30005") {
					} else {
						alert(response.data.msg);
					}
				})
			},
			goThird(){
				window.location.href="https://mc.youpintong.com/qh.jsp";
			}
		},
		components: {
			pesonalInfo,
			rechargePrompt,
			payPrompt
		}
	}
</script>

<style scoped="scoped" >
	.fixing {
		width: 100%;
		height:100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size:0.24rem;
		padding: 1rem 0;
	}

	.home {
		width: 100%;
		height:100%;
		box-sizing: border-box;
		background: #F7F7F7;
		font-size:0.24rem;
		overflow:hidden;
		color:#979797;
		
	}
	
	.mid-autumn{
		/* background:url("../assets/img/midAutum/topBg.png")no-repeat; */
		background-size:100% 100%;
	}
	.mid-autumn .banner,.mid-autumn .banner2{
		position:relative;
		display:flex;
		justify-content: space-between;
		padding:0.2rem ;
		background:linear-gradient(149deg,rgba(254,236,205,1) 0%,rgba(255,243,224,1) 100%);
	}
	.mid-autumn .banner>div:nth-child(1),.mid-autumn .banner2>div:nth-child(1){
		font-size:0.24rem;
		font-family:PingFangSC-Regular,PingFangSC;
		font-weight:400;
		color:#A26140;
		line-height:0.33rem;
	}
	.mid-autumn .banner2{
		margin-top:0.14rem;
	}
	.mid-autumn  .header2 .records{
		float: right;
		width:1.31rem;
		text-align:center;
		height: 0.53rem;
		font-size:0.36rem;
		font-family:Source Han Sans SC;
		font-weight:400;
		color:rgba(51,51,51,1);
		text-align:center;
		line-height: 0.53rem;
		background:linear-gradient(143deg,rgba(255,243,216,0.84),rgba(255,211,127,0.84));
		margin-top:0.28rem;
	}

	
	.mid-autumn   .header .records {
		float: right;
		width:1.31rem;
		text-align:center;
		height: 0.53rem;
		font-size:0.36rem;
		font-family:Source Han Sans SC;
		font-weight:400;
		color:#fff;
		text-align:center;
		line-height: 0.53rem;
		background:#4C90E1;
		border-radius:0.27rem 0px 0px 0.27rem;
		margin-top:0.28rem;

	}

	.mid-autumn .phoneNumber{
		width:100%;
		background-size:100% 100%;
		text-align:center;
		margin-bottom:0.14rem;
		background:#fff;
	}
	
	.mid-autumn .phoneNumber input{
		height:1.23rem;
		background:transparent;
		outline:none;
		border:none;
		font-size:0.88rem;
		font-family:PingFangSC;
		font-weight:500;
		color:rgba(34,34,34,1);
		padding-left:0.2rem;
		border-bottom:0.01rem solid #fff;
	}
	.mid-autumn .phoneNumber .text{
		width:6rem;
		text-align:left;
		padding-left:0.2rem;
		margin:0 auto;
		font-size:0.18rem;
		font-family:PingFangSC;
		font-weight:400;
		color:rgba(109,109,109,1);
	}
	.mid-autumn .phoneNumber	input::-webkit-input-placeholder {
		font-size:0.5rem;
		font-family:PingFangSC;
		font-weight:500;
		color:#6D6D6D;
    }
   .mid-autumn .phoneNumber input::-moz-placeholder {
       font-size:0.5rem;
		font-family:PingFangSC;
		font-weight:500;
		color:#6D6D6D;
    }
  .mid-autumn .phoneNumber  input:-moz-placeholder {
      font-size:0.5rem;
		font-family:PingFangSC;
		font-weight:500;
		color:#6D6D6D;
    }
  .mid-autumn .phoneNumber  input:-ms-input-placeholder {
      font-size:0.5rem;
		font-family:PingFangSC;
		font-weight:500;
		color:#6D6D6D;
    }


.mid-autumn .goRecord{
	font-size:0.24rem;
	font-family:PingFangSC-Regular,PingFangSC;
	font-weight:400;
	color:#D5AE8F;
	line-height:0.33rem;
}


.recharge-list{
	background:#fff;
}
.recharge-list ul{
	display:flex;
	flex-wrap: wrap;
	padding-left:0;
	padding-top:0.2rem;
}
/* .recharge-list ul .checked .money{
	color:rgba(232,191,127,1);
}
.recharge-list ul .checked .price{
	color:rgba(232,191,127,1);
}
.recharge-list ul .checked .gift{
	color:rgba(232,191,127,1);
} */
.recharge-list ul .checked{
	background:url("../assets/img/yellowBg.png")no-repeat;
	background-size:100% 100%;
}
/* .recharge-list ul .checked::before{
	content:"";
	background:url("../assets/img/youhui.png")no-repeat;
	background-size:100% 100%;
	width:1.25rem;
	height:0.46rem;
	position:absolute;
	top:-0.2rem;
	left:-0.1rem;
} */
.recharge-list ul li{
	list-style:none;
	background:rgba(255,255,255,1);
	box-shadow:0 0rem 0rem 0 rgba(221,221,221,0.5);
	border-radius:0.1rem;
	border:0.01rem solid #F7F7F7;
	flex:0 0 30%;
	padding:0.55rem 0.3rem 0.38rem 0.3rem ;
	box-sizing: border-box;
	margin-left:0.2rem;
	margin-bottom:0.2rem;
	position:relative;
	-webkit-tap-highlight-color: transparent;
}
.recharge-list ul li .money{
	font-size:0.52rem;
font-family:Impact;
color:#A57458;
text-align:center;
line-height:0.63rem;
}
.recharge-list ul li .price{
font-size:0.24rem;
font-family:PingFangSC-Light,PingFangSC;
font-weight:300;
color:#A57458;
text-align:center;
line-height:0.33rem;
margin:0.05rem 0 0.12rem 0;
}
.recharge-list ul li .gift{
font-size:0.16rem;
font-family:PingFangSC-Regular,PingFangSC;
font-weight:400;
color:#A57458;
text-align:center;
line-height:0.22rem;
}


.youku-list{
	background:#fff;
	padding-top:0.2rem;
}
.youku-list ul{
	display:flex;
	flex-wrap: wrap;
	padding-left:0;
	padding-top:0.2rem;
}
.youku-list .youkuSEVEN{
	background:url("../assets/img/youkuSEVEN.png")no-repeat;
	background-size:100% 100%;
	width:7.08rem;
	height:2.27rem;
	margin:0 auto ;
	position:relative;
}
.youku-list .youkuSEVEN img{
	width:1.8rem;
	height:0.6rem;
	background-size:100% 100%;
	position:absolute;
	right:0.26rem;
	bottom:0.44rem;
}
/* .youku-list ul .checked .money{
	color:#E5BA7A;
}
.youku-list ul .checked .price{
	color:#E8BF7F;
}
.youku-list ul .checked .gift{
	color:#613A07;
} */
.youku-list ul .checked{
	background:url("../assets/img/yellowBg.png")no-repeat;
	background-size:100% 100%;
}

/* .youku-list ul .checked .yuan{
color:#EAC485
}
.youku-list ul .checked::before{
	content:"";
	background:url("../assets/img/youhui.png")no-repeat;
	background-size:100% 100%;
	width:1.25rem;
	height:0.46rem;
	position:absolute;
	top:-0.2rem;
	left:-0.1rem;
} */
.youku-list ul li{
	list-style:none;
	background:rgba(255,255,255,1);
	box-shadow:0 0rem 0rem 0 rgba(221,221,221,0.5);
	border-radius:0.1rem;
	border:0.01rem solid #F7F7F7;
	flex:0 0 30%;
	padding:0.55rem 0rem 0.38rem 0rem ;
	box-sizing: border-box;
	margin-left:0.2rem;
	margin-bottom:0.2rem;
	position:relative;
	-webkit-tap-highlight-color: transparent;

}
.youku-list ul li .icon2{
	display: inline-block;
	position: absolute;
	top: -.1rem;
	width: .96rem;
	height: .76rem;
	background: url("../assets/img/youkuCard/weekCard.png");
	background-size:100% 100%;
}
.youku-list ul li .icon3{
	display: inline-block;
	position: absolute;
	top: -.1rem;
	width: .96rem;
	height: .76rem;
	background: url("../assets/img/youkuCard/monCard.png");
	background-size:100% 100%;
}
.youku-list ul li .icon4{
	display: inline-block;
	position: absolute;
	top: -.1rem;
	width: .96rem;
	height: .76rem;
	background: url("../assets/img/youkuCard/seasonCard.png");
	background-size:100% 100%;
}
.youku-list ul li .icon5{
	display: inline-block;
	position: absolute;
	top: -.1rem;
	width: .96rem;
	height: .76rem;
	background: url("../assets/img/youkuCard/halfyearCard.png");
	background-size:100% 100%;
}
.youku-list ul li .icon6{
	display: inline-block;
	position: absolute;
	top: -.1rem;
	width: .96rem;
	height: .76rem;
	background: url("../assets/img/youkuCard/yearsCard.png");
	background-size:100% 100%;
}
.youku-list ul li .price{
	font-size:0.52rem;
font-family:Impact;
color:#A57458;
text-align:center;
line-height:0.63rem;
}
.youku-list ul li .money{
font-size:0.24rem;
font-family:PingFangSC-Regular,PingFangSC;
font-weight:300;
color:#D5AE8F;
text-align:center;
line-height:0.33rem;
text-decoration: line-through;
}
.youku-list ul li .gift{
font-size:0.24rem;
font-family:PingFangSC-Light,PingFangSC;
font-weight:300;
color:#A57458;
text-align:center;
line-height:0.33rem;
margin:0.05rem 0 0.12rem 0;
}
.youku-list ul li .yuan{
font-size:0.24rem;
font-family:PingFangSC-Semibold,PingFangSC;
font-weight:600;
color:#A57458;
line-height:0.33rem;
}

.rules{
	padding:0.19rem 0.28rem 0.3rem 0.28rem;
	font-size:0.24rem;
font-family:PingFangSC;
font-weight:400;
color:rgba(151,151,151,1);
line-height:0.33rem;
}
.rules .title{
	font-size:0.24rem;
font-family:PingFangSC;
font-weight:500;
color:rgba(78,78,78,1);
margin-bottom:0.3rem;
}




.btn-area{
	height:1.42rem;
	background:rgba(255,255,255,1);
	box-shadow:0 0.01rem 0 0 rgba(207,207,207,0.5);
	display:flex;
	justify-content: center;
	align-items:center;
}
.btn-area .confirm{
	width:6.99rem;
	height:1rem;
	background:linear-gradient(146deg,rgba(252,228,169,1) 0%,rgba(227,181,116,1) 100%);
	border-radius:1rem;
	font-size:0.36rem;
font-family:PingFangSC;
font-weight:500;
color:rgba(90,51,1,1);
text-align:center;
line-height:1rem;
}
	.listContent{
		overflow:auto;
		/* background:url("../assets/img/midAutum/midAutumBg.png")no-repeat; */
		background-size:100% 120%;
		background-attachment: local;
		width:100%;
	} 
	.listContent .ios-describe {
		width: 100%;
		height: 5rem;
		padding: .2rem;
		box-sizing: border-box;
		font-size: .4rem;
		font-weight: 600;
	}
</style>


// WEBPACK FOOTER //
// src/components/home.vue